import * as React from 'react';
import { DraggableProps } from '../DragAndDrop/Draggable';

export interface SortableListBaseProps extends DraggableProps {
  dataHook?: string;
  /** function that specifying where the item can be inserted
   * @default 'any'
   */
  insertPosition?: SortableListBaseInsertPosition;
  /** in case of wrong position of item during drag you can force SortableListBase to use portals */
  usePortal?: boolean;
  /**
   if you are having nested SortableListBases,
   list that you are currently dragging need to be marked as dragPreview
   inside of renderItem callback
   */
  dragPreview?: boolean;
  /** list of items with {id: any} */
  items?: object[];
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** className of the first items parent container */
  contentClassName?: string;
}

export class SortableListBase extends React.PureComponent<SortableListBaseProps> {}

export type SortableListBaseInsertPosition = 'start' | 'end' | 'any';
